import i18n from '../i18n';

export function bindingData(response) {
  if (!response || Number(response.code) !== 200) {
    const error = new Error(response && response.msg || i18n.t('frontend.funds.connection_failed'));
    error.code = Number(response && response.code);
    throw error;
  }
  if (!response.data || typeof response.data !== 'object') throw new Error(i18n.t('frontend.funds.binding_load_failed'));
  return response.data;
}

export function bindingError(vm, error, fallback) {
  vm.$toast(error.message || fallback);
  if (error.code === 401 && vm.$route.path !== '/Login') {
    localStorage.removeItem('token');
    vm.$router.replace('/Login');
  }
}

export function validUsdtAddress(network, address) {
  if (network === 'trc20') return /^T[1-9A-HJ-NP-Za-km-z]{33}$/.test(address);
  if (network === 'erc20') return /^0x[0-9a-fA-F]{40}$/.test(address) && !/^0x0{40}$/.test(address);
  return network === 'btc' && (/^[13][1-9A-HJ-NP-Za-km-z]{25,34}$/.test(address) || /^bc1[ac-hj-np-z02-9]{11,71}$/.test(address));
}
